import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { useHistory } from "react-router-dom";
import ActionTable from "../../../components/table/ActionTable";
import { formatDateTime, mergeParams } from "../../../helpers/helpers";
import Form from "../../../components/form";
import comunidade from "../../../services/comunidade";
import AppContext from "../../../container/context";

export default function Lista({ location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        periodoInicio: ``,
        periodoFim: "",
        nome: "",
        email: "",
        gerouPedido: 0,
      },
      location
    )
  );
  const [totais, setTotais] = useState({});
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listar();
  }, []);

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    comunidade
      .get("admin/preCadastros/listar", filtrosEnviar)
      .then((res) => {
        const preCadastros = res.preCadastros;

        preCadastros.forEach((item) => {
          item.registro = formatDateTime(item.registro, "D/M/Y h:m");
          item.resultou = !item.ultimoPedidoPedidoId ? (
            "Não"
          ) : (
            <h4>
              Sim{" "}
              <a
                href={`${window.location.origin}/app/comunidade-pedidos/${item.ultimoPedidoPedidoId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                ({item.ultimoPedidoPedidoId})
              </a>
            </h4>
          );
        });

        setRegistros(preCadastros);
        setTotais(res);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os pré cadastros. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      periodoInicio: {
        label: "Período início",
        type: "date",
        space: 6,
        value: filtros.periodoInicio,
      },
      periodoFim: {
        label: "Período fim",
        type: "date",
        space: 6,
        value: filtros.periodoFim,
      },
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: filtros.nome,
      },
      email: {
        type: "text",
        label: "Email",
        space: 3,
        value: filtros.email,
      },
      gerouPedido: {
        type: "select",
        label: "Resultou em pedido",
        space: 3,
        array: {
          data: [
            { id: 0, nome: "Inidiferente" },
            { id: 1, nome: "Sim" },
            { id: -1, nome: "Não" },
          ],
          value: "id",
          desc: "nome",
        },
        value: filtros.gerouPedido,
      },
    },

    submit: {
      label: "Buscar",
      action: listar,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      registros: {
        label: "Registros",
        type: "date",
        space: 4,
        readOnly: true,
        value: totais.qtdTotal ? totais.qtdTotal : "0",
      },
      resultaram: {
        label: "Resultaram em pedido",
        type: "date",
        space: 4,
        readOnly: true,
        value: totais.qtdResultaramEmPedido
          ? totais.qtdResultaramEmPedido
          : "0",
      },
      naoResultaram: {
        label: "Não resultaram em pedido",
        type: "text",
        readOnly: true,
        space: 4,
        value: totais.qtdNaoResultaramEmPedido
          ? totais.qtdNaoResultaramEmPedido
          : "0",
      },
    },
  };

  const tCadastros = {
    title: "Cadastros",
    key: "id",
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Email",
        name: "email",
      },
      {
        label: "Telefone",
        name: "telefone",
      },
      {
        label: "Data/hora de cadastro",
        name: "registro",
      },
      {
        label: "Resultou em pedido",
        name: "resultou",
      },
    ],
    array: registros,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      <Form formData={fTotais} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tCadastros} />
      )}
    </div>
  );
}
